export const COMMON_LEGEND_OPTIONS = { itemGap: 30, show: true, itemWidth: 15, icon: 'rect' }

// A vertical legend listed beside the chart; it scrolls instead of overflowing the chart height.
// Hovering an entry shows its full name, as long entries are truncated (see the text widths below).
export const SIDE_LEGEND_OPTIONS = {
  ...COMMON_LEGEND_OPTIONS,
  type: 'scroll',
  orient: 'vertical',
  top: 'middle',
  itemGap: 12,
  tooltip: { show: true },
}

// Room reserved on the right of the bar chart for its legend
export const BAR_SIDE_LEGEND_WIDTH = 190
// The legend column minus the icon, the gap after it and the legend padding: longer labels are
// truncated so they never grow over the bars
export const BAR_SIDE_LEGEND_TEXT_WIDTH = BAR_SIDE_LEGEND_WIDTH - 30

// Below these chart widths the legend no longer fits beside the plot and moves below it
export const BAR_SIDE_LEGEND_MIN_WIDTH = 640
export const PIE_SIDE_LEGEND_MIN_WIDTH = 560

// Donut layout with the legend beside it: the donut fills the left half and the legend starts at
// the middle, so at the narrowest side-legend layout the text gets half of
// PIE_SIDE_LEGEND_MIN_WIDTH, minus the icon, gap and padding
export const PIE_SIDE_LEGEND_LEFT = '50%'
export const PIE_SIDE_LEGEND_TEXT_WIDTH = PIE_SIDE_LEGEND_MIN_WIDTH * 0.5 - 30
export const PIE_SIDE_LEGEND_SERIES_LAYOUT = { center: ['25%', '50%'], radius: ['38%', '65%'] }
